// Icon paths for the application
// Icons are imported from src/assets/images/layouts

import dashboardIcon from "../assets/images/layouts/dashboard-icon.svg"
import sidebarLeftIcon from "../assets/images/layouts/sidebar-left-icon.svg"
import searchSidebarIcon from "../assets/images/layouts/search-sidebar-icon.svg"
import chevronSidebarIcon from "../assets/images/layouts/chevron-sidebar-icon.svg"
import addCircleSidebarIcon from "../assets/images/layouts/add-circle-sidbar-icon.svg"
import expandSidebarIcon from "../assets/images/layouts/expand-sidebar-icon.svg"
import projectsIcon from "../assets/images/layouts/projects.svg"
// Dashboard action icons
import playIcon from "../assets/images/dasboard/resume-dashboard-icon.svg"
import timerIcon from "../assets/images/dasboard/timer-icon.svg"
import hourglassIcon from "../assets/images/dasboard/hourglass-icon.svg"
import arrowRightIcon from "../assets/images/icon/arrow-right.svg"
import arrowRight12Icon from "../assets/images/icon/arrow-right-12.svg"
import arrowRightBlackIcon from "../assets/images/layouts/arrow-right-black.svg"
import refreshIcon from "../assets/images/dasboard/location-tick-dashboard-icon.svg"
import reloadIcon from "../assets/images/icon/refresh.svg"
import plusIcon from "../assets/images/dasboard/add-dashboard-icon.svg"
import sendIcon from "../assets/images/dasboard/send-dashboard-icon.svg"
import thumbPlaceholderIcon from "../assets/images/dasboard/thumb-placeholder.svg"
import thumbnailPlaceholderIcon from "../assets/images/dasboard/thumbnail-placeholder.svg"
import messageSparkle1 from "../assets/images/dasboard/messages/sparkle-1.svg"
import messageSparkle2 from "../assets/images/dasboard/messages/sparkle-2.svg"
import messageSparkle3 from "../assets/images/dasboard/messages/sparkle-3.svg"
import messageSparkle4 from "../assets/images/dasboard/messages/sparkle-4.svg"
import messageBubbleDotsGray from "../assets/images/dasboard/messages/bubble-dots-gray.svg"
import messageBubbleDotsDark from "../assets/images/dasboard/messages/bubble-dots-dark.svg"
import messageShareIcon from "../assets/images/dasboard/messages/share.svg"
import messageDownloadIcon from "../assets/images/dasboard/messages/download-arrow.svg"
import messageExportIcon from "../assets/images/dasboard/messages/export.svg"
import messageToolbarPlus from "../assets/images/dasboard/messages/toolbar-plus.svg"
import messageToolbarType from "../assets/images/dasboard/messages/toolbar-type.svg"
import messageToolbarSmile from "../assets/images/dasboard/messages/toolbar-smile.svg"
import messageToolbarAt from "../assets/images/dasboard/messages/toolbar-at.svg"
import messageToolbarPaperclip from "../assets/images/dasboard/messages/toolbar-paperclip.svg"
import messageSearchCollab from "../assets/images/dasboard/messages/search-collab.svg"
import profileHeadphone from "../assets/images/profile/headphone.svg"
import profileBook from "../assets/images/profile/book.svg"
import profileLocationTick from "../assets/images/profile/location-tick.svg"
import taskIcon from "../assets/images/layouts/dashboard-icon.svg"
import focusTaskIcon from "../assets/images/dasboard/focus-task-dashboard.svg"
import callsForArtistIcon from "../assets/images/layouts/calls-for-artist-icon.svg"
import colaboratorsIcon from "../assets/images/layouts/colaborators-icon.svg"
import soloSessionIcon from "../assets/images/icon/solo-session.svg"
import invitesIcon from "../assets/images/layouts/invites-icon.svg"
import cityHubIcon from "../assets/images/layouts/city-hub.svg"
import rewardXpIcon from "../assets/images/layouts/reward-xp-icon.svg"
import myProfileIcon from "../assets/images/layouts/my-profile-icon.svg"
import flagsNavIcon from "../assets/images/layouts/flags-icon.svg"
import searchHeaderIcon from "../assets/images/layouts/search-header-icon.svg"
import notificationHeaderIcon from "../assets/images/layouts/notification-header-icon.svg"
import messageQuestionIcon from "../assets/images/layouts/message-question-header-icon.svg"
import locationTickIcon from "../assets/images/layouts/location-tick-header-icon.svg"

import chevronDownIcon from "../assets/images/icon/arrow-down.svg"
import chevronLeftIcon from "../assets/images/icon/chevron-left-icon.svg"
import chevronRightIcon from "../assets/images/icon/chevron-right-icon.svg"
import checkIcon from "../assets/images/icon/check.svg"
import arrowLeftIcon from "../assets/images/icon/arrow-left.svg"
import editIcon from "../assets/images/icon/edit.svg"
import trashIcon from "../assets/images/icon/trash.svg"
import archiveIcon from "../assets/images/icon/archive.svg"
import messageTextIcon from "../assets/images/icon/message-text.svg"
import messageTextBlueIcon from "../assets/images/icon/message-text-blue.svg"
import removeCircleIcon from "../assets/images/icon/remove-circle.svg"
import zoomOutIcon from "../assets/images/icon/zoom out.svg"
import playWhiteIcon from "../assets/images/icon/play-white.svg"
import playNavyIcon from "../assets/images/icon/play-navy.svg"
import checkGreenIcon from "../assets/images/icon/check-green.svg"
import tickWhiteIcon from "../assets/images/icon/tick-white.svg"
import calendarIcon from "../assets/images/icon/calendar.svg"
import activityHeaderIcon from "../assets/images/icon/activity/activity.svg"
import activityFlagIcon from "../assets/images/icon/activity/flag.svg"
import profileFlagUserIcon from "../assets/images/icon/profile/flag-user.svg"
import profileInviteSendIcon from "../assets/images/icon/profile/invite-send.svg"
import profileMessageIcon from "../assets/images/icon/profile/message.svg"
import activityProfileIcon from "../assets/images/icon/activity/profile.svg"
import activityDocumentDownloadIcon from "../assets/images/icon/activity/document-download.svg"
import activityDocumentTextIcon from "../assets/images/icon/activity/document-text.svg"
import activitySmsTrackingIcon from "../assets/images/icon/activity/sms-tracking.svg"
import activityMessageQuestionIcon from "../assets/images/icon/activity/message-question.svg"
import activityTaskIcon from "../assets/images/icon/activity/task.svg"
import activityAwardIcon from "../assets/images/icon/activity/award.svg"
import activityClockIcon from "../assets/images/icon/activity/clock.svg"
import activityMapIcon from "../assets/images/icon/activity/map.svg"
import activityCameraIcon from "../assets/images/icon/activity/camera.svg"
import activitySecurityIcon from "../assets/images/icon/activity/security.svg"
import activityTicketStarIcon from "../assets/images/icon/activity/ticket-star.svg"
import activityUserBlueIcon from "../assets/images/icon/activity/user-blue.svg"
import activitySearchStatusBlueIcon from "../assets/images/icon/activity/search-status-blue.svg"
import activityAwardBlueIcon from "../assets/images/icon/activity/award-blue.svg"
import activityDirectInboxBlueIcon from "../assets/images/icon/activity/direct-inbox-blue.svg"
import activityMapBlueIcon from "../assets/images/icon/activity/map-blue.svg"
import pendingStarIcon from "../assets/images/icon/pending/star.svg"
import pendingSearchStatusIcon from "../assets/images/icon/pending/search-status.svg"
import pendingCameraIcon from "../assets/images/icon/pending/camera.svg"
import pendingFlagIcon from "../assets/images/icon/pending/flag.svg"
import pendingArrangeCircleIcon from "../assets/images/icon/pending/arrange-circle-2.svg"
import flagWithdrawAIcon from "../assets/images/icon/flags/withdraw-a.svg"
import flagWithdrawBIcon from "../assets/images/icon/flags/withdraw-b.svg"
import flagEditIcon from "../assets/images/icon/flags/edit.svg"
import flagLocationTickIcon from "../assets/images/icon/flags/location-tick.svg"
import flagArrowRightIcon from "../assets/images/icon/flags/arrow-right.svg"
import flagArrowDownIcon from "../assets/images/icon/flags/arrow-down.svg"
import flagSendIcon from "../assets/images/icon/flags/send.svg"
import flagCheckRectIcon from "../assets/images/icon/flags/check-rect.svg"
import flagCheckRectCheckedIcon from "../assets/images/icon/flags/check-rect-checked.svg"
import flagExportIcon from "../assets/images/icon/flags/export.svg"
import peopleIcon from "../assets/images/icon/people.svg"
import userIcon from "../assets/images/icon/user.svg"
import timerOrangeIcon from "../assets/images/icon/timer-orange.svg"
import cityHubTimerIcon from "../assets/images/icon/city-hub/timer.svg"
import cityHubLevelStarIcon from "../assets/images/icon/city-hub/level-star.svg"
import cityHubCameraIcon from "../assets/images/icon/city-hub/camera.svg"
import cityHubCreatorIcon from "../assets/images/icon/city-hub/creator.svg"
import cityHubStarIcon from "../assets/images/icon/city-hub/star.svg"
import saveAddIcon from "../assets/images/icon/save-add.svg"
import emptyStateIcon from "../assets/images/icon/empty-state.svg"
import logoutIcon from "../assets/images/icon/logout.svg"
import likeIcon from "../assets/images/icon/like.svg"
import likeFillIcon from "../assets/images/icon/like-fill.svg"
import likeUnfillIcon from "../assets/images/icon/like-unfill.svg"
import heartIcon from "../assets/images/icon/heart.svg"
import heartFillIcon from "../assets/images/icon/heart-fill.svg"
import heartOutlineRedIcon from "../assets/images/icon/heart-outline-red.svg"
import pauseIcon from "../assets/images/icon/pause.svg"
import minimizeIcon from "../assets/images/icon/minimize-02.svg"
import starFilledIcon from "../assets/images/icon/star-filled.svg"
import starEmptyIcon from "../assets/images/icon/star-empty.svg"
import starRatingIcon from "../assets/images/icon/star-rating.svg"
import eyeIcon from "../assets/images/icon/eye.svg"
import eyeSlashIcon from "../assets/images/icon/eye-slash.svg"
import callInformalMessagesIcon from "../assets/images/icon/calls/informal-messages.svg"
import callFormalSearchStatusIcon from "../assets/images/icon/calls/formal-search-status.svg"
import callInfoCircleIcon from "../assets/images/icon/calls/info-circle-gray.svg"
import callArrowRightOrangeIcon from "../assets/images/icon/calls/arrow-right-orange.svg"
import callArrowRightGreenIcon from "../assets/images/icon/calls/arrow-right-green.svg"
import callUploadExportIcon from "../assets/images/icon/calls/upload-export.svg"
import callRemoveXIcon from "../assets/images/icon/calls/remove-x.svg"
import callArchiveTickIcon from "../assets/images/icon/calls/archive-tick.svg"
import callLocationGreenIcon from "../assets/images/icon/calls/location-green.svg"
import tickDoubleIcon from "../assets/images/icon/tick-double.svg"
import tickDoubleWhiteIcon from "../assets/images/icon/tick-double-white.svg"
import rewardsMedalIcon from "../assets/images/icon/rewards-medal.svg"
import rewardsLevelUpIcon from "../assets/images/icon/rewards-level-up.svg"
import rewardsGiftIcon from "../assets/images/icon/rewards-gift.svg"
import rewardsSendSquareIcon from "../assets/images/icon/rewards-send-square.svg"
import rewardsActivityIcon from "../assets/images/icon/rewards-activity.svg"
import rewardsGiftBlueIcon from "../assets/images/icon/rewards-gift-blue.svg"
import rewardsGiftClaimedIcon from "../assets/images/icon/rewards-gift-claimed.svg"
import rewardXpRedIcon from "../assets/images/icon/reward-xp-red.svg"

// Admin layout icons (Figma exports)
import adminGrid4Icon from "../assets/images/admin/grid-4.svg"
import adminNotificationStatusIcon from "../assets/images/admin/notification-status.svg"
import adminMapIcon from "../assets/images/admin/map.svg"
import adminDataIcon from "../assets/images/admin/data.svg"
import adminClockIcon from "../assets/images/admin/clock.svg"
import adminUserIcon from "../assets/images/admin/user.svg"
import adminAwardIcon from "../assets/images/admin/award.svg"
import adminDirectInboxIcon from "../assets/images/admin/direct-inbox.svg"
import adminCameraIcon from "../assets/images/admin/camera.svg"
import adminShapesIcon from "../assets/images/admin/shapes.svg"
import adminDocumentTextIcon from "../assets/images/admin/document-text.svg"
import adminMessageQuestionIcon from "../assets/images/admin/message-question.svg"
import adminSmsTrackingIcon from "../assets/images/admin/sms-tracking.svg"
import adminPeopleIcon from "../assets/images/admin/people.svg"
import adminSecurityIcon from "../assets/images/admin/security.svg"
import adminSetting2Icon from "../assets/images/admin/setting-2.svg"
import adminAddCircleIcon from "../assets/images/admin/add-circle.svg"
import adminNotificationIcon from "../assets/images/admin/notification.svg"
import adminMessageSearchIcon from "../assets/images/admin/message-search.svg"
import adminActivityLogIcon from "../assets/images/admin/activity-log.svg"
import adminLocationTickIcon from "../assets/images/admin/location-tick.svg"
import adminSearchIcon from "../assets/images/admin/search.svg"
import adminEyeIcon from "../assets/images/admin/eye.svg"
import adminAvatarPlaceholder from "../assets/images/admin/avatar.png"
import adminDocumentDownloadIcon from "../assets/images/admin/document-download.svg"

export const ICONS = {
  // Navigation icons
  navDashboard: dashboardIcon,
  sidebarLeft: sidebarLeftIcon,
  searchSidebar: searchSidebarIcon,
  chevronSidebar: chevronSidebarIcon,
  addCircleSidebar: addCircleSidebarIcon,
  expandSidebar: expandSidebarIcon,
  navProjects: projectsIcon,

  // Dashboard icons (placeholders - replace with actual SVG files)
  play: playIcon,
  timer: timerIcon,
  hourglass: hourglassIcon,
  arrowRight: arrowRightIcon,
  arrowRight12: arrowRight12Icon,
  arrowRightBlack: arrowRightBlackIcon,
  refresh: refreshIcon,
  reload: reloadIcon,
  plus: plusIcon,
  emptyState: emptyStateIcon,
  send: sendIcon,
  thumbPlaceholder: thumbPlaceholderIcon,
  thumbnailPlaceholder: thumbnailPlaceholderIcon,
  messageSparkle1,
  messageSparkle2,
  messageSparkle3,
  messageSparkle4,
  messageBubbleDotsGray,
  messageBubbleDotsDark,
  messageShare: messageShareIcon,
  messageDownload: messageDownloadIcon,
  messageExport: messageExportIcon,
  messageToolbarPlus,
  messageToolbarType,
  messageToolbarSmile,
  messageToolbarAt,
  messageToolbarPaperclip,
  messageSearchCollab,
  profileHeadphone,
  profileBook,
  profileLocationTick,
  task: taskIcon,
  focusTask: focusTaskIcon,
  session: colaboratorsIcon,
  soloSession: soloSessionIcon,
  navCallsForArtist: callsForArtistIcon,
  navCollaborators: colaboratorsIcon,
  navInvites: invitesIcon,
  navCityHub: cityHubIcon,
  navRewards: rewardXpIcon,
  navProfile: myProfileIcon,
  navFlags: flagsNavIcon,

  // Header icons
  search: searchHeaderIcon,
  notification: notificationHeaderIcon,
  help: messageQuestionIcon,
  activityLog: activityHeaderIcon,

  // City icon
  city: locationTickIcon,

  // Listing / table icons
  chevronDown: chevronDownIcon,
  chevronLeft: chevronLeftIcon,
  chevronRight: chevronRightIcon,
  check: checkIcon,
  arrowLeft: arrowLeftIcon,
  edit: editIcon,
  trash: trashIcon,
  archive: archiveIcon,
  messageText: messageTextIcon,
  messageTextBlue: messageTextBlueIcon,
  removeCircle: removeCircleIcon,
  zoomOut: zoomOutIcon,
  playWhite: playWhiteIcon,
  playNavy: playNavyIcon,
  checkGreen: checkGreenIcon,
  tickWhite: tickWhiteIcon,
  calendar: calendarIcon,
  people: peopleIcon,
  user: userIcon,
  timerOrange: timerOrangeIcon,
  cityHubTimer: cityHubTimerIcon,
  cityHubLevelStar: cityHubLevelStarIcon,
  cityHubCamera: cityHubCameraIcon,
  cityHubCreator: cityHubCreatorIcon,
  cityHubStar: cityHubStarIcon,
  saveAdd: saveAddIcon,
  logout: logoutIcon,
  pause: pauseIcon,
  minimize: minimizeIcon,
  starFilled: starFilledIcon,
  starEmpty: starEmptyIcon,
  starRating: starRatingIcon,
  like: likeIcon,
  likeFill: likeFillIcon,
  likeUnfill: likeUnfillIcon,
  heart: heartIcon,
  heartFill: heartFillIcon,
  heartOutlineRed: heartOutlineRedIcon,
  eye: eyeIcon,
  eyeSlash: eyeSlashIcon,

  // Calls for Artist — Create Inbox modal
  callInformalMessages: callInformalMessagesIcon,
  callFormalSearchStatus: callFormalSearchStatusIcon,
  callInfoCircle: callInfoCircleIcon,
  callArrowRightOrange: callArrowRightOrangeIcon,
  callArrowRightGreen: callArrowRightGreenIcon,
  callUploadExport: callUploadExportIcon,
  callRemoveX: callRemoveXIcon,
  callArchiveTick: callArchiveTickIcon,
  callLocationGreen: callLocationGreenIcon,

  // Notifications
  tickDouble: tickDoubleIcon,
  tickDoubleWhite: tickDoubleWhiteIcon,

  // Rewards & XP
  rewardsMedal: rewardsMedalIcon,
  rewardsLevelUp: rewardsLevelUpIcon,
  rewardsGift: rewardsGiftIcon,
  rewardsSendSquare: rewardsSendSquareIcon,
  rewardsActivity: rewardsActivityIcon,
  rewardsGiftBlue: rewardsGiftBlueIcon,
  rewardsGiftClaimed: rewardsGiftClaimedIcon,
  rewardsXpRed: rewardXpRedIcon,

  // Admin
  adminGrid4: adminGrid4Icon,
  adminDashboard: adminNotificationStatusIcon,
  adminCities: adminMapIcon,
  adminProjects: adminDataIcon,
  adminSessions: adminClockIcon,
  adminMembers: adminUserIcon,
  adminRewards: adminAwardIcon,
  adminInbox: adminDirectInboxIcon,
  adminPhotography: adminCameraIcon,
  adminArtsGenome: adminShapesIcon,
  adminBlogs: adminDocumentTextIcon,
  adminRequests: adminMessageQuestionIcon,
  adminFlags: adminDocumentTextIcon,
  adminMailgun: adminSmsTrackingIcon,
  adminStaff: adminPeopleIcon,
  adminRoles: adminSecurityIcon,
  adminSettings: adminSetting2Icon,
  adminAddCircle: adminAddCircleIcon,
  adminNotification: adminNotificationIcon,
  adminMessageSearch: adminMessageSearchIcon,
  adminActivityLog: adminActivityLogIcon,
  adminCityLocation: adminLocationTickIcon,
  adminSearch: adminSearchIcon,
  adminEye: adminEyeIcon,
  adminAvatar: adminAvatarPlaceholder,
  adminDocumentDownload: adminDocumentDownloadIcon,

  activityFlag: activityFlagIcon,
  profileFlagUser: profileFlagUserIcon,
  profileInviteSend: profileInviteSendIcon,
  profileMessage: profileMessageIcon,
  activityProfile: activityProfileIcon,
  activityDocumentDownload: activityDocumentDownloadIcon,
  activityDocumentText: activityDocumentTextIcon,
  activitySmsTracking: activitySmsTrackingIcon,
  activityMessage: activityMessageQuestionIcon,
  activityTask: activityTaskIcon,
  activityAward: activityAwardIcon,
  activityClock: activityClockIcon,
  activityMap: activityMapIcon,
  activityCamera: activityCameraIcon,
  activitySecurity: activitySecurityIcon,
  activityTicketStar: activityTicketStarIcon,
  activityUserBlue: activityUserBlueIcon,
  activitySearchStatusBlue: activitySearchStatusBlueIcon,
  activityAwardBlue: activityAwardBlueIcon,
  activityDirectInboxBlue: activityDirectInboxBlueIcon,
  activityMapBlue: activityMapBlueIcon,
  pendingStar: pendingStarIcon,
  pendingSearchStatus: pendingSearchStatusIcon,
  pendingCamera: pendingCameraIcon,
  pendingFlag: pendingFlagIcon,
  pendingArrangeCircle: pendingArrangeCircleIcon,

  flagWithdrawA: flagWithdrawAIcon,
  flagWithdrawB: flagWithdrawBIcon,
  flagEdit: flagEditIcon,
  flagLocationTick: flagLocationTickIcon,
  flagArrowRight: flagArrowRightIcon,
  flagArrowDown: flagArrowDownIcon,
  flagSend: flagSendIcon,
  flagCheckRect: flagCheckRectIcon,
  flagCheckRectChecked: flagCheckRectCheckedIcon,
  flagExport: flagExportIcon,
}
